import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AccessibilityButton, AccessibilityListBox, AccessibilityClickableDiv, AccessibilityHidden, useAccessibilityEscapeKey } from '@skillz/accessibility';
import Arrow from "../iconsOld/arrow/Arrow";
import classes from "./Collapse.module.css";

const Collapse = ({ title, children, expanded, dropClass, IconTemplate, bgColor, dropClassBtnWrapper, dropClassContent, clearAll, clearFilters, closeCollapse, setCloseCollapse, listboxId, selector, onToggle }) => {

    const [showContent, setShowContent] = useState(!!expanded);
    
    useEffect(() => {
        setShowContent(expanded);
    }, [expanded]);

    const texts = useSelector(state => state.translate.texts);
    const handleCollapse = e => {
        e?.stopPropagation();
        const nextShowContent = !showContent;
        setShowContent(nextShowContent)
        onToggle && onToggle(nextShowContent)
        setCloseCollapse && setCloseCollapse(false)
    }

    useEffect(() => {
        if (closeCollapse === true)
            setShowContent(expanded)
    }, [closeCollapse, expanded])

    const handleCloseCollapse = () => {
        if (showContent) {
            handleCollapse();
        }
    }

    useAccessibilityEscapeKey(handleCloseCollapse)

    return (
        <div className={`${classes.CollapseWrapper} ${dropClass}`}>
            <AccessibilityButton
                onClick={handleCollapse}
                accessibilityExpanded
                id={`${listboxId}Trigger`}
                className={`${classes.BtnWrapper} ${dropClassBtnWrapper}`}
                style={{ backgroundColor: bgColor }} >
                <div className={classes.Title}>{title}</div>
                <div className={classes.ClearOpen}
                    aria-label={showContent ? texts.closeSubMenu || 'close' : texts.openSubMenu || 'open'}>
                    <AccessibilityHidden>
                        {IconTemplate ?
                            <IconTemplate showContent={showContent} /> :
                            <Arrow direction={showContent ? "down" : "left"} />
                        }
                    </AccessibilityHidden>
                </div>
            </AccessibilityButton>
            {clearAll &&
                <div className={classes.ClearAll}>
                    <AccessibilityClickableDiv onClick={(e) => { clearFilters(); e.stopPropagation(); }}>
                        <p>{texts.clearAll}</p>
                    </AccessibilityClickableDiv>
                </div>}
            <AccessibilityListBox
                listboxId={listboxId}
                hidden={!showContent}
                selector={selector}
                className={`${classes.Content} ${!showContent && classes.ContentHidden} ${dropClassContent}`}>
                {children}
            </AccessibilityListBox>
        </div>
    )
}
export default Collapse;